import type { ContainingCity } from '../api/cities';
import './CityLabel.css';

interface Props {
  city: ContainingCity | null;
}

export function CityLabel({ city }: Props) {
  console.debug('[cabin] CityLabel render', city);
  if (!city) return null;
  return (
    <div className="city-label" aria-live="polite">
      <div className="city-label-name">{city.name}</div>
      {city.region && <div className="city-label-region">{city.region}</div>}
    </div>
  );
}
